import analytics from '../../../analytics'

export const googleProviderId = 'accounts.google.com'

const authDefault = {
  id_token: '',
  token_type: '',
  idpId: '',
  expires_in: '',
  expires_at: '',
  first_issued_at: '',
  login_hint: ''
}

const profileDefault = {
  id: '',
  name: '',
  givenName: '',
  familyName: '',
  imageUrl: '',
  email: ''
}

export const googleModule = {
  state: {
    authResponse: authDefault,
    profile: profileDefault,
    loading: false
  },
  getters: {
    googleLoginEntry: state => {
      return { [googleProviderId]: state.authResponse.id_token }
    },
    googleEmailAddress: state => {
      return state.profile.email
    },
    googleName: state => {
      return state.profile.name
    },
    googleSigninLoading: state => {
      return state.loading
    }
  },
  mutations: {
    setGoogleSigninLoading (state, googleSigninLoading) {
      state.loading = googleSigninLoading
    },
    /**
     * Successful Google SignIn
     */
    onGoogleSignInSuccess (state, googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      const basicProfile = googleUser.getBasicProfile()
      const authResponse = googleUser.getAuthResponse()

      state.profile.id = basicProfile.getId()
      state.profile.name = basicProfile.getName()
      state.profile.givenName = basicProfile.getGivenName()
      state.profile.familyName = basicProfile.getFamilyName()
      state.profile.imageUrl = basicProfile.getImageUrl()
      state.profile.email = basicProfile.getEmail()

      state.authResponse.id_token = authResponse.id_token
      state.authResponse.token_type = authResponse.token_type
      state.authResponse.idpId = authResponse.idpId
      state.authResponse.expires_in = authResponse.expires_in
      state.authResponse.expires_at = authResponse.expires_at
      state.authResponse.first_issued_at = authResponse.first_issued_at
      state.authResponse.login_hint = authResponse.login_hint

      console.log('Google Sign-In Success: %O', googleUser)
    },

    /**
     * Failed Google SignIn
     */
    onGoogleSignInError (state, error) {
      // `error` contains any error occurred.
      state.loading = false
      console.log('Google Sign-In authorization failed: ', error.reason)
    },

    /**
     * Google SignOut
     */
    onGoogleSignOut (state) {
      state.profile = profileDefault
      state.authResponse = authDefault

      console.log('Google Sign-Out Success')
    }
  },
  actions: {
    /**
     * Action to sign out the currently signed in googleUser
     */
    googleSignOut (context) {
      var start = analytics.currentTime()
      window.gapi.auth2.getAuthInstance().signOut(() => {
        var end = analytics.currentTime()
        analytics.time('API', 'signout-google', end - start, 'success')
        context.commit('onGoogleSignOut')
      })
    },
    onLogin (context) {
      context.commit('setGoogleSigninLoading', false)
    }
  }
}

export default googleModule



// WEBPACK FOOTER //
// ./src/store/auth/idp/google.js